import { ReleaseNoteSectionViewOf } from 'bff';
import { editorialBody, editorialParagraph } from '../editorial';
import { RichText } from '../RichText';

export const TextSection = ({
  section,
}: {
  section: ReleaseNoteSectionViewOf<'text'>;
}) => (
  <div className={editorialBody}>
    <RichText text={section.content.body} className={editorialParagraph} />
  </div>
);
